import React, { useState } from "react";
import { Check, CheckCheck, Copy, Send, UserPlus } from "lucide-react";

export default function ReferralPage({ userData }) {
  const [referrals, setReferrals] = useState(userData.referrals);
  const [copied, setCopied] = useState(false);

  //   const handleResend = (phone) => {
  //     alert(`Resending invite to ${phone}`);
  //     // Implement actual resend logic (API call)
  //   };

  const handleInvite = async () => {
    const shareMessage = `Hey!

I am sending this to make Zero Deposit renting possible for you at any property of your choice with CirclePe. 
    
Sign up using my referral code ${userData?.referralCode} and rent at Zero Deposit for the 1st time ever!
    
Link: https://join.circlepe.in?rf_code=${userData?.referralCode}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Get Rewards!",
          text: shareMessage,
          url: ``, // You can customize this URL
        });
        console.log("Referral shared successfully!");
      } catch (error) {
        console.error("Error sharing referral:", error);
      }
    } else {
      // Fallback for browsers that don't support Web Share API
      const shareUrl = `whatsapp://send?text=${encodeURIComponent(
        shareMessage
      )}`;
      window.open(shareUrl, "_blank");
    }
  };

  //   const handleInvite = () => {
  //     alert("Invite a new user clicked!");
  //     // Implement actual invite logic (open modal, input form, etc.)
  //   };

  const handleResend = (phone) => {
    const message = `Hey!\n\nI am sending this to make Zero Deposit renting possible for you at any property of your choice with CirclePe.\n\nSign up using my referral code *${userData?.referralCode}* and rent at Zero Deposit for the 1st time ever!\n\n🔗 Link: https://join.circlepe.in?rf_code=${userData?.referralCode}`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phone}?text=${encodedMessage}`;

    window.open(whatsappUrl, "_blank");
  };

  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(userData?.referralCode);
    } catch (e) {
      console.log(e);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 500); // Hide message after 2 seconds
  };

  return (
    <div className="min-h-screen flex flex-col items-center bg-[#0d0d0d] text-white px-4">
      {/* Top Section - Heading + Invite Button */}
      <div className="w-full max-w-lg flex justify-between items-center py-6 sticky top-0 bg-[#0d0d0d] z-10">
        <h1 className=" text-xl tracking-wide text-[#eee]">
          Refer & Earn <br />{" "}
          <span
            className="my-2 flex gap-2 items-center text-[#999] text-sm font-semibold tracking-widest cursor-pointer transition"
            onClick={handleCopy}
          >
            {copied ? (
              <CheckCheck size={20} className="text-green-500" />
            ) : (
              <Copy size={20} />
            )}
            {copied ? "Copied!" : userData?.referralCode}
          </span>
        </h1>
        <button
          onClick={handleInvite}
          className="text-sm px-5 py-2 rounded-full bg-blue-600 hover:bg-blue-500 transition flex items-center gap-2"
        >
          <UserPlus className="w-4 h-4" /> Invite
        </button>
      </div>

      {/* Reward Banner */}
      <div
        onClick={handleInvite}
        className="w-full rounded border border-[#555] my-2"
      >
        <img src="/rfe.svg" />
      </div>

      <div className="w-full max-w-lg px-4 mt-4">
        <span className="text-sm text-gray-400">Referrals</span>

        {referrals.length > 0 ? (
          referrals.map((referral) => (
            <div
              key={referral.id}
              className="flex items-center justify-between p-4 border-b border-[#333] text-gray-200"
            >
              <div>
                <p className="min-w-max flex gap-3 text-sm mb-1">
                  {referral.toUser?.firstName &&
                  referral.toUser?.firstName !== ""
                    ? `${referral.toUser?.firstName}`
                    : " Jone Doe"}
                  <span className=" text-[#666]">
                    {referral.toUser?.phone && referral.toUser?.phone !== ""
                      ? `${referral.toUser?.phone}`
                      : ""}
                  </span>
                </p>

                <p className="text-xs text-[#666]">
                  Status: {"  "}
                  <span
                    className={`text-${
                      referral.accepted ? "green" : "yellow"
                    }-400`}
                  >
                    {referral.accepted
                      ? referral.completed
                        ? "Completed "
                        : "Accepted "
                      : "Pending"}
                  </span>
                </p>
              </div>
              {!referral.accepted
                      && !referral.completed && <button
                onClick={() => handleResend(referral?.toUser?.phone)}
                className="text-sm p-4 rounded-full  hover:bg-gray-50/5 transition flex items-center gap-1"
              >
                <Send className="h-5 aspect-square text-[#BBB]" />
              </button>}
            </div>
          ))
        ) : (
          <p className="text-gray-400 text-center">No referrals yet.</p>
        )}
      </div>
    </div>
  );
}

// Example Usage
const userData = {
  referrals: [
    {
      id: "67bf2aa79c6ae0423f4a3ea5",
      toUserId: "67bf2aa69c6ae0423f4a3ea3",
      senderId: "67bf298323cb95159a242d10",
      accepted: false,
      completed: false,
      rewarded: false,
      rewardId: "67bf2aa79c6ae0423f4a3ea4",
      referralCode: "YKSZBPZJ",
      type: "JOIN_CLUB",
      createdAt: "2025-02-26T14:52:22.987Z",
      updatedAt: "2025-02-26T14:52:22.987Z",
      toUser: {
        firstName: "",
        lastName: null,
        phone: "9718325800",
      },
    },
  ],
};
